'use client';

import type { ButtonVariantProps } from '../types';
import ButtonComponent, { ButtonSizes, ButtonVariants } from '@pixum/button';
import Download from '@pixum/svg-icon/lib/Standard/Download';
import Text, { TextTag, TEXT_VARIANT } from '@pixum/text';
import { useDeviceInfo } from 'hooks';
import { handleRedirectToSoftwareDownloadPageClick } from '../utils';

/**
 * `Download Button` component displays a download button.
 *
 * @component
 * @param link - A Link Object.
 * @param constants - The list of constants needed.
 *
 */
export function ButtonWithSoftwareDownload({ link, constants = {} }: ButtonVariantProps) {
  const deviceInfo = useDeviceInfo();
  const operatingSystem = deviceInfo.operatingSystem;
  const url = link?.url || '';

  const handleClick = () => {
    handleRedirectToSoftwareDownloadPageClick(url, operatingSystem);
  };

  const designNow = constants['i18n_design_now'] as string;
  const photoSoftware = constants['i18n_photo_software'] as string;

  return (
    <ButtonComponent
      className="button--download button-for-desktop"
      label={link?.title}
      size={ButtonSizes.LARGE}
      type="button"
      variant={ButtonVariants.STRONG}
      onClick={handleClick}
    >
      <Download />
      <div className="button--download--text">
        <Text tag={TextTag.SPAN} variant={TEXT_VARIANT.BUTTON}>
          {designNow}
        </Text>
        <Text variant={TEXT_VARIANT.CAPTION_XS}>{photoSoftware}</Text>
      </div>
    </ButtonComponent>
  );
}
